import Environment from "./Environment";

export const TOKENS = [
    { NAME: "GEMS", tokenImg: "newgemslogosvg", tokenAddress: Environment?.gems, decimals: 18 },
    { NAME: "ETH", tokenImg: "eth-icon", tokenAddress: Environment.eth, decimals: 18 },
    { NAME: "USDT", tokenImg: "usdt", tokenAddress: Environment.busd, decimals: 6 },
    { NAME: "USDC", tokenImg: "usdc", tokenAddress: Environment.usdc, decimals: 6 },
    { NAME: "TOMI", tokenImg: "tomi-icon-drop", tokenAddress: Environment.tomi, decimals: 18 }, // Could not reliably determine decimals
    { NAME: "WBTC", tokenImg: "wbtc", tokenAddress: Environment.wbtc, decimals: 8 },
    { NAME: "LINK", tokenImg: "link", tokenAddress: Environment.link, decimals: 18 },
    { NAME: "PEPE", tokenImg: "pepe", tokenAddress: Environment.pepe, decimals: 18 },
    { NAME: "UNI", tokenImg: "uniswap", tokenAddress: Environment.unisape, decimals: 18 },
    { NAME: "DOP", tokenImg: "dop", tokenAddress: Environment.dop, decimals: 18 },
];